import Cookies from "js-cookie";
export const cookie = "1213123ewifhsirewurwradminsdfsfsdf24242r";

/**
 * Matches the 24h lifetime of the token it holds (SurgoAdminApi's createJwt), so
 * the cookie stops existing at the same moment the token stops working.
 *
 * The previous `expires=2147483647` was a unix timestamp where the header wants an
 * HTTP-date, so browsers ignored it and kept the cookie for the browser session.
 */
const MAX_AGE_SECONDS = 24 * 60 * 60;

export const setCookie = (data: any) => {
  document.cookie = `${cookie}=${data}; max-age=${MAX_AGE_SECONDS}; path=/; Secure; SameSite=Strict`;
};

export const getCookie = () => {
  return Cookies.get(cookie) ? Cookies.get(cookie) : null;
};

export const removeCookie = () => {
  return Cookies.remove(cookie);
};
